const formatTime = (timeString) => {
  let splitTimeString = timeString.split(":");
  let ampm = splitTimeString[2].substr(
    splitTimeString[2].length - 2,
    splitTimeString.length
  );
  return `${splitTimeString[0]}:${splitTimeString[1]} ${ampm ? ampm : ""}`;
};
export default formatTime;

const formatDate = (d) => {
  /*eslint no-extend-native: ["error", { "exceptions": ["Number"] }]*/
  Number.prototype.padLeft = function (base, chr) {
    var len = String(base || 10).length - String(this).length + 1;
    return len > 0 ? new Array(len).join(chr || "0") + this : this;
  };
  return (
    [d.getDate().padLeft(), (d.getMonth() + 1).padLeft(), d.getFullYear()].join(
      "/"
    ) +
    " " +
    [
      d.getHours().padLeft(),
      d.getMinutes().padLeft(),
      d.getSeconds().padLeft()
    ].join(":")
  );
};
export { formatDate };
